import {
    CcReviewReviewItem,
    CcReviewReviewRevision,
    CcReviewReviewItemState,
    CcReviewReviewHistory,
} from "server/models"
import { inferLiteral, StateType, OrderType } from "client/utils"
import * as types from "./types"

// list

export const showCcReviewReviewColumnSettings = (show: boolean) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_COLUMN_SETTINGS),
    show,
})
export const setCcReviewReviewItemList = (itemList: types.ReviewReviewItemList) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_ITEM_LIST),
    itemList,
})
export const setCcReviewReviewItemIds = (itemIds: readonly number[]) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_ITEM_IDS),
    itemIds,
})


export const setCcReviewReviewRevisionList = (itemId: number, revisions: CcReviewReviewRevision[]) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_REVISION_LIST),
    itemId,
    revisions,
})
export const setCcReviewReviewRevisionActive = (itemId: number, revision: CcReviewReviewRevision) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_REVISION_ACTIVE_LIST),
    itemId,
    revision,
})


export const setCcReviewReviewItemStateList = (itemId: number, state: CcReviewReviewItemState) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_ITEM_STATE_LIST),
    itemId,
    state,
})
export const setCcReviewReviewItemHistoryList = (itemId: number, itemHistoryList: CcReviewReviewHistory[]) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_ITEM_HISTORY_LIST),
    itemId,
    itemHistoryList,
})
export const setCcReviewReviewTempAnswerList = (itemId: number, tempAnswers: types.ReviewReviewTempAnswerByUser) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_TEMP_ANSWER_LIST),
    itemId,
    tempAnswers,
})


export const setCcReviewReviewSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_SELECTED),
    selected,
})
export const setCcReviewReviewSort = (sortColumn: keyof CcReviewReviewItem, sortOrder: OrderType) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_SORT),
    sortColumn,
    sortOrder,
})
export const setCcReviewReviewLoadState = (state: StateType) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_LOAD_STATE),
    state,
})
export const setCcReviewReviewReloadList = (value: boolean) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_RELOAD_LIST),
    value,
})

// popup menu

export const setCcReviewReviewActive = (active: CcReviewReviewItem) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_ACTIVE),
    active,
})
export const setCcReviewReviewPopupMenuShow = (show: boolean) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_POPUP_MENU_SHOW),
    show,
})
export const setCcReviewReviewPopupMenuTarget = (target: HTMLElement) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_POPUP_MENU_TARGET),
    target,
})
export const setCcReviewReviewShowConfirmDelete = (show: boolean) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_SHOW_CONFIRM_DELETE),
    show,
})

// view history and edit item

export const setCcReviewReviewItemDetails = (details: CcReviewReviewItem) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_ITEM_DETAILS),
    details,
})
export const setCcReviewReviewItemState = (state: CcReviewReviewItemState) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_ITEM_STATE),
    state,
})
export const setCcReviewReviewItemHistory = (history: CcReviewReviewHistory[]) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_ITEM_HISTORY),
    history,
})
export const setCcReviewReviewTempAnswers = (answers: types.ReviewReviewTempAnswerByUser) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_TEMP_ANSWERS),
    answers,
})
export const setCcReviewReviewTempAnswerHistory = (history: CcReviewReviewHistory) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_TEMP_ANSWER_HISTORY),
    history,
})
export const setCcReviewReviewReloadAnswer = (value: boolean) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_RELOAD_ANSWER),
    value,
})
export const setCcReviewReviewReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_REVIEW_REVIEW_RELOAD_EDIT),
    value,
})
